import AssignTrapsPopover from './AssignTrapsPopover'
import enhance from './AssignTrapsPopover.enhancer'

export default enhance(AssignTrapsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/AssignTrapsPopover/index.js